import { useState } from 'react';
import { FiRefreshCw, FiX } from 'react-icons/fi';
import { usePWAManager } from '../../lib/pwa';

export default function PWAUpdatePrompt() {
  const { updateAvailable, updatePWA } = usePWAManager();
  const [isVisible, setIsVisible] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = async () => {
    setIsUpdating(true);
    const success = await updatePWA();
    
    if (!success) {
      setIsUpdating(false);
    }
    // If successful, page will reload automatically
  };

  const handleDismiss = () => {
    setIsVisible(false);
  };

  if (!updateAvailable || !isVisible) {
    return null;
  }

  return (
    <div className="fixed top-4 left-4 right-4 md:left-1/2 md:right-auto md:transform md:-translate-x-1/2 md:max-w-md z-50">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start justify-between">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center mr-3">
              <FiRefreshCw className="h-4 w-4 text-white" />
            </div>
            <div>
              <h3 className="font-medium text-blue-900">Update Available</h3>
              <p className="text-sm text-blue-700">
                A new version of TopDial is ready
              </p>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="text-blue-400 hover:text-blue-600 p-1"
          >
            <FiX className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-3 flex space-x-2">
          <button
            onClick={handleUpdate}
            disabled={isUpdating}
            className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 transition-colors disabled:opacity-50 flex items-center"
          >
            {isUpdating ? (
              <>
                <div className="animate-spin rounded-full h-3 w-3 border-2 border-white border-t-transparent mr-2"></div>
                Updating...
              </>
            ) : (
              <>
                <FiRefreshCw className="h-3 w-3 mr-2" />
                Update Now
              </>
            )}
          </button>
          <button
            onClick={handleDismiss}
            className="px-4 py-2 border border-blue-300 rounded-lg text-sm font-medium text-blue-700 hover:bg-blue-100 transition-colors"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
